import { render, staticRenderFns } from "./AssignmentReport.vue?vue&type=template&id=39b7a5b0&scoped=true&"
import script from "./AssignmentReport.vue?vue&type=script&lang=js&"
export * from "./AssignmentReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b7a5b0",
  null
  
)

export default component.exports